import { render, staticRenderFns } from "./InputExpress.vue?vue&type=template&id=32673902"
import script from "./InputExpress.vue?vue&type=script&lang=ts"
export * from "./InputExpress.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports